<template>
  <div class="side-help-tooltips"
       :class="selector">
    <transition name="group-fade">
      <HelpFloat v-if="isFixed && currentItem"
                 :title="currentItem.title"
                 @toggle-tooltip="onToggle"/>
    </transition>
    <div class="side-help-tooltips__wrap">
      <template v-if="isFixed && currentItem">
        <button type="button" class="side-help-tooltips__close" @click.prevent="onToggle">
          <span class="side-help-tooltips__close-text">{{ $tVacancy('Back to vacancy') }}</span>
          <span class="side-help-tooltips__close-ico">
            <BaseSvg name="ico-close"/>
          </span>
        </button>
      </template>
      <transition name="group-fade">

        <HelpTooltip v-if="showResult"
                     :number="count"
                     :title="count ?  count + $tVacancy('vacancies are already waiting for you') : $tVacancy('No vacancies found')"
                     :description="'<p>' + $tVacancy('But we still recommend supplementing your resume for a more accurate selection exactly for your requirements.') + '</p>'"
                     class="side-help-tooltips__inner"/>
        <HelpTooltip v-else-if="currentItem"
                     :key="currentId"
                     :videoSrc="currentItem.videoSrc"
                     :src="currentItem.src"
                     :icon="currentItem.icon"
                     :icon-wrap-class="currentItem.iconClass"
                     :title="currentItem.title"
                     :description="currentItem.description"
                     class="side-help-tooltips__inner"/>
      </transition>
    </div>
  </div>
</template>

<script>
  import {blockScroll, unBlockScroll} from '../../helpers/scroll'
  import HelpTooltip from '../HelpTooltip'
  import HelpFloat from '../HelpTooltipFloat'

  import img5 from '../../assets/img/vacancy-help-tooltip/5.jpg'

  export default {
    components: {
      HelpTooltip,
      HelpFloat
    },
    props: {
      currentId: {
        type: [Number, String]
      },
      isFixed: {
        type: Boolean,
        default: false
      },
      hints: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        isShowVideo: false,
        isOpen: false,
        showResult: false,
        subscribeCancel: null,
      }
    },
    computed: {
      items() {
        const { hints } = this;
        const defaultHint = () => ({ title: '', description: '', image: '' });
        const parseHint = ({ title, text, image } = defaultHint()) => ({ title, description: text, src: image });

        return {
          1: parseHint(hints[0]),
          2: parseHint(hints[1]),
          3: parseHint(hints[2]),
          4: parseHint(hints[3]),
          5: {
            src: img5,
            title: this.$tVacancyEditHint('hint_5_title_1') + '\n' +
              this.$tVacancyEditHint('hint_5_title_2'),
            description: '<p>' + this.$tVacancyEditHint('hint_5_description') + '</p>'
          },
          6: {
            ...parseHint(hints[4]),
            btn: {
              text: this.$tVacancyEditHint('hint_6_btn'),
              callBack: this.showDocuments
            }
          },
          7: parseHint(hints[5]),
          8: parseHint(hints[6]),
          9: parseHint(hints[7]),
          10: parseHint(hints[8]),
        };
      },
      selector() {
        return {
          '_fixed': this.isFixed,
          '_open': this.isOpen
        }
      },
      currentItem() {
        if (!this.currentId) return false
        return this.items[this.currentId]
      },
      count() {
        return this.$store.state.resumeEdit?.resume?.find_vacancies || 0
      }
    },
    methods: {
      onShowVideo() {
        this.isShowVideo = true
      },
      onToggle() {
        if (!this.isFixed) return

        if (this.isOpen) {
          unBlockScroll()
          this.isOpen = false
        } else {
          blockScroll()
          this.isOpen = true
        }
      },

      showDocuments() {
        console.log('showDocuments')
      }
    },
    created() {
      this.subscribeCancel = this.$store.subscribe((mutation) => {
        if (mutation.type === 'resumeEdit/setResume') {
          this.showResult = true
          // this.$emit('focus', null)
        }
      })
    },
    beforeDestroy() {
      if (typeof this.subscribeCancel === 'function') {
        this.subscribeCancel()
      }
    },
    watch: {
      currentId(value) {
        if (value) {
          this.showResult = false
        }
      }
    }
  }
</script>

<style>
  .group-fade-enter {
    opacity: 0;
  }

  .group-fade-enter-active {
  }

  .group-fade-leave {
    transition: none;
    opacity: 0;
  }

  .group-fade-leave-active {
    transition: none;
    opacity: 0;
  }
</style>
